import { TemplateRestriction } from '../ts/types';

const templateRestriction: {
    [index: string]: TemplateRestriction;
} = {
    xRace: {
        isCommercial: true,
        materials: ['chikara'],
    },
    pumbaa: {
        isCommercial: true,
        materials: ['icarexPc31'],
    },
    magnet: {
        isCommercial: false,
        materials: ['icarexPc31'],
    },
    p3: {
        isCommercial: false,
        materials: ['icarexPc31'],
    },
    '90Three': {
        isCommercial: false,
        materials: ['icarexPc31'],
    },
};

export default templateRestriction;
